import React, { useEffect, useState } from "react";
import "admin-lte/dist/css/adminlte.min.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Sidebar2 from "./Sidebar2";
import toast from "react-hot-toast";

const base_url = process.env.REACT_APP_API_URL;

const AdminHeader = ({ toggleSidebar, isSidebarOpen, isMobile }) => {
  const [data, setData] = useState();
  const [isSidebar2Open, setIsSidebar2Open] = useState(false);
  const [role, setRole]= useState('');
  const [allow, setAllow]= useState(false);
  const [stake, setStake]= useState(0);

  const auth = localStorage.getItem("admin");

  const fetchBalance = async () => {
    try {
      const response = await axios.get(
        base_url + "/api/webapi/admin/listMember",
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      // console.log('rpee head',response);
      if (response?.status) {
        const bal = response?.data.datas;
        const rol= response?.data?.role;
        setData(bal);
        setRole(rol);
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  };

  const handleSubmit= async()=> {
    try{
      if(stake <= 0){
        return toast.error('chips should be graeater value');
      }
      const response= await axios.post(base_url + '/api/creditChips',
        {stake},
        {
          headers:{
            Authorization: auth,
            'content-type':'application/json',
          }
        }
      )

      if(response?.data?.success){
        setAllow(!allow);
        fetchBalance();
        toast.success(response?.data?.message);
      }else{
        toast.error(response?.data?.message);
      }

    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    fetchBalance();
  }, []);

  return (
    <div className="wrapper">
      {/* Navbar */}
      <nav
        className={`main-header navbar navbar-expand admin_header ${
          isSidebarOpen ? "" : "open-content-wrapper"
        }`}

        style={{
              background: "linear-gradient(45deg, rgb(93 161 222), rgb(62 216 224))"
        }}
      >
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item hamburger">
            <Link
              className="nav-link text-white fw-bold"
              onClick={(e) => {
                e.preventDefault();
                toggleSidebar(); // ensure toggleSidebar works in both mobile and desktop
              }}
              href="#"
              role="button"
            >
              <i className="fas fa-bars fs-5"></i>
            </Link>
          </li>
        </ul>

          {/* mobile view navbar */}
          
          {isMobile && (
          <div className="mobile-toggle-container ml-2">
            {!isSidebarOpen && (
              <Link
                data-target="nav-mobile"
                className="sidenav-trigger"
                onClick={toggleSidebar}
              >
                <img
                  src="/assets/images/hamburger.svg"
                  alt="Open Menu"
                  className="hamburger-icon"
                  style={{ width: "24px", height: "24px" }}
                />
              </Link>
            ) 
          }
        </div>
          )}
          

        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <div className="balance">
              Balance : <span className="amount">{data || 0}</span>
            </div>
          </li>
        </ul>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link
              className="nav-link"
              data-widget="fullscreen"
              href="#"
              role="button"
            >
              <i className="fas fa-expand-arrows-alt"></i>
            </Link>
          </li>

          {/* Profile Image to Toggle Sidebar2 */}
          <li className="nav-item m-2" onClick={() => setIsSidebar2Open(!isSidebar2Open)} style={{ cursor: "pointer" }}>
            <img
              src="https://tse3.mm.bing.net/th?id=OIP.c2mM1ZkzOlxhYtugBEUU5QHaHa&pid=Api&P=0&h=180"
              alt="Profile"
              style={{ height: "30px", width: "30px", borderRadius: "50%" }}
            />
          </li>
        </ul>
      </nav>

      {/* Sidebar2 */}
      <Sidebar2 setIsSidebar2Open={setIsSidebar2Open} isOpen={isSidebar2Open} setAllow={setAllow} allow={allow} role={role} toggleSidebar={() => setIsSidebar2Open(!isSidebar2Open)} />

    {allow && (
      <div
        className="modal fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.6)", // dark overlay for focus
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              borderRadius: "20px",
              overflow: "hidden",
              border: "none",
              boxShadow: "0px 8px 20px rgba(0,0,0,0.3)",
            }}
          >
            {/* Header */}
            <div
              className="modal-header"
              style={{
                background: "linear-gradient(45deg, #4facfe, #00f2fe)", // matches sidebar
                color: "white",
                borderBottom: "none",
              }}
            >
              <h5 className="modal-title fw-bold">
                <i className="fa fa-coins me-2"></i> Add Chips
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setAllow(false)}
              ></button>
            </div>

            {/* Body */}
            <div
              className="modal-body"
              style={{
                backgroundColor: "#f9fbfd",
              }}
            >
              <label className="form-label fw-bold text-dark">
                Enter Chips Amount
              </label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter chips..."
                onChange={(e)=>setStake(e.target.value)}
                value={stake}
                style={{
                  borderRadius: "12px",
                  border: "1px solid #d1d5db",
                  padding: "10px",
                }}
              />
            </div>

            {/* Footer */}
            <div
              className="modal-footer d-flex justify-content-between"
              style={{
                backgroundColor: "#f9fbfd",
                borderTop: "none",
              }}
            >
              <button
                type="button"
                className="btn"
                style={{
                  background: "linear-gradient(45deg, #ff4b2b, #ff416c)",
                  color: "white",
                  borderRadius: "30px",
                  padding: "8px 20px",
                  fontWeight: "bold",
                  transition: "0.3s",
                }}
                onMouseOver={(e) => (e.target.style.opacity = "0.9")}
                onMouseOut={(e) => (e.target.style.opacity = "1")}
                onClick={() => setAllow(false)}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn"
                onClick={(e)=>handleSubmit(e)}
                style={{
                  background: "linear-gradient(45deg, #11998e, #38ef7d)", // green gradient
                  color: "white",
                  borderRadius: "30px",
                  padding: "8px 20px",
                  fontWeight: "bold",
                  transition: "0.3s",
                }}
                onMouseOver={(e) => (e.target.style.opacity = "0.9")}
                onMouseOut={(e) => (e.target.style.opacity = "1")}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    )}


    </div>
  );
};

export default AdminHeader;